<template>
  <v-app id="dzs-document">
<!--    <router-view/> -->
    <home/>
  </v-app>
</template>

<script>
import Home from "./components/Home";

export default {
  name: 'App',

  components: {
    Home,
  },

  data: () => ({

  }),
};
</script>
<style>
  html, .section-booking-calendar {
    color: rgba(0,0,0,.87);
  }
  .section-booking-calendar h2{
    text-align: center;
  }
  #dzs-document > div{
    display: flex;
    align-items: center;
    color: transparent;
  }
  .row-content-center{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .marg-pad-null {
    padding: 0;
    margin: 0;
  }
  *, :after, :before {
    background-repeat: no-repeat;
    box-sizing: inherit;
  }
  #content-block{
    max-width: 990px;
    min-height: 607px;
    width: 100%;
    margin: 15px;
    box-sizing: border-box;
    border-radius: 5px;
    background-color: #fff;
    box-shadow: 0 15px 25px 0 hsla(0,0%,53.3%,.25);
    padding: 15px;
  }
  h1, h2, p {
    color: rgba(0, 0, 0, 0.87);
  }
  h1, p {
    text-align: center;
  }
  h1 {
    margin-bottom: 20px;
  }
  .header-h1{
    text-align: center;
  }
  .header-content-block-h1{
    min-height: 36px;
  }
  .header-content-block-p{
    min-height: 48px;
    max-width: 400px;
    margin-left: auto;
    margin-right: auto;
  }
  /* data piker styles */
  .v-picker{
    width: 100%;
  }
  #dzs-document .v-picker__body{
    width: 100%;
  }
  .icon-booking-calendar{
    color: #2a6ebb!important;
  }
  .v-application .blue {
      background-color: #2a6ebb!important;
      border-color: #2a6ebb!important;
  }
  .top-border-center{
    display: flex;
    justify-content: center;
    align-items: center;
    border-top: 1px solid #000;
    border-bottom: 1px solid #000;
  }
  .input-label-star-red .v-label:after{
    color:red;
    content:"*";
  }
  #section-confirm-meeting .v-select-list{
    width: 100%;
  }
  .div-center{
    margin-right: auto;
    margin-left: auto;
  }
  .icon-meeting-details {
    color: #2a6ebb!important;
    margin-right: 15px;
  }


  .v-select-list{
    width: 100%;
    text-align: center;
    max-height: 200px;
  }
  .v-list-item{
    background-color: #fff;
  }

  .v-text-field.v-input--dense:not(.v-text-field--outlined) input {
    display: none;
  }
  .v-select__selection{
    width: 100%;
  }
  .v-list-item__title{
    text-align: start;
  }

</style>
